export const firebaseConfig = {
  apiKey: 'AIzaSyCaZXv2_z7Zu1qWt-w4T7vs8dqlm5g2Krs',
  authDomain: 'clientes-agendapro.firebaseapp.com',
  projectId: 'clientes-agendapro',
  storageBucket: 'clientes-agendapro.appspot.com',
  messagingSenderId: '533472793446',
  appId: '1:533472793446:web:e3e6024d02439ef8852ea7',
};
